import React from "react";

export default function RunningLoader() {
  return (
    <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-gradient-to-b from-sky-50 via-white to-amber-50">
      {/* Animated School Icon Container */}
      <div className="relative flex items-center justify-center mb-8">
        <div className="absolute w-32 h-32 bg-orange-100 rounded-full animate-ping opacity-75"></div>
        <div className="relative text-7xl animate-bounce">🏫</div>
      </div>

      {/* Loading Text */}
      <h2 className="text-2xl font-bold text-slate-800 mb-2">Please Wait...</h2>
      <p className="text-slate-500 mb-6">Setting up your dashboard</p>

      {/* Bouncing Dots */}
      <div className="flex space-x-2">
        <div className="w-3 h-3 bg-orange-500 rounded-full animate-bounce [animation-delay:-0.3s]"></div>
        <div className="w-3 h-3 bg-orange-500 rounded-full animate-bounce [animation-delay:-0.15s]"></div>
        <div className="w-3 h-3 bg-orange-500 rounded-full animate-bounce"></div>
      </div>
    </div>
  );
}
